import React from 'react';

import {
  Container,
  Image,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  MasonryGrid,
  Text,
  Slider,
} from '../../../components';
import { SCREEN_NORMAL } from '../../../config/constants';
import { ParagraphTextImageGrid as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextImageGridProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextImageGrid: React.FC<ParagraphTextImageGridProps> = ({ entity }) => {
  const paragraphTextImageGrid = entity.toJS();

  const title = paragraphTextImageGrid.field_title[0]?.value;
  const body = paragraphTextImageGrid.field_body[0]?.processed || '';
  const media = paragraphTextImageGrid.field_media_items;

  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  const imageGridItems = media
    // Either return 2 or 4 items
    .filter((_, i) => !((media.length === 3 && i === 2) || i > 3))
    // Build a list of images, with the correct ratios and sizes.
    .map((item, i) => {
      const caption = item.entity.field_caption[0]?.value;
      const imageStyles = item.styles;

      // 1st or 4th image are 4:3
      // 2nd and 3rd are 3:4
      let ratio: string = '3_4';
      if (media.length < 4) {
        ratio = '1_1';
      } else if (i % 3 === 0) {
        ratio = '4_3';
      }

      const src = ['xs', 'sm', 'md', 'xl'].map((sizes) => {
        const style = `ratio_${ratio}_${sizes}`;
        return `${imageStyles?.[style] || ''}`;
      });

      return (
        <Image
          src={src}
          alt={caption}
          lazyload={!isMobile}
        />
      );
    });

  return (
    <div className="Paragraph ParagraphTextImageGrid">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Text
              title={title}
              text={body}
              className="text--regular"
            />
          </div>

          <div className="col-12">
            {isMobile && media.length === 4 ? (
              <div className="ParagraphTextImageGrid__slider">
                <Slider>
                  {imageGridItems}
                </Slider>
              </div>
            ) : (
              <Container>
                <MasonryGrid items={imageGridItems} />
              </Container>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextImageGrid;
